import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import VueAxios from 'vue-axios';
import MiniLoader from './components/MiniLoader.vue';
import ErrorAlert from './components/ErrorAlert.vue';
import SuccessAlert from './components/SuccessAlert.vue';
import globalErrorHandler from './views/globalErrorHandler';
import Loader from './components/Loader.vue';
import VueTheMask from 'vue-the-mask';
import placeHolder from './components/PlaceHolderImage.vue';
import Select2 from 'vue3-select2-component';
import { createI18n } from 'vue-i18n'
import English from '@/language/English';
import Arabic from '@/language/Arabic';
import moment from 'moment';
import 'moment/locale/ar';
import 'moment/locale/en-gb';
import vSelect from "vue-select"; 
import "vue-select/dist/vue-select.css";
import popupCharge_Wallet from './components/popupCharge_Wallet.vue';


axios.defaults.baseURL = store.getters['BACKEND_URL'];
// axios.defaults.headers.common['X-Language'] = localStorage.getItem('lang') ?? 'ar';
axios.interceptors.request.use((config) => {
  config.headers["X-Language"] = localStorage.getItem('lang') ?? 'ar';
  if (localStorage.getItem('userToken')) {
    config.headers["X-Aqaria-Token"] = localStorage.getItem('userToken');
  }
  return config;
});
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("userToken");
      router.push("/login").catch(() => {});
    }
    return Promise.reject(error);
  }
);

store.dispatch('checkUser');

let timelang = 'ar';
if(localStorage.getItem('lang') && localStorage.getItem('lang') !='ar' ){
  timelang = 'en-gb';
}
moment.locale(timelang);

const i18n = createI18n({
  // something vue-i18n options here ...
  legacy: false,
  locale: localStorage.getItem('lang') ?? 'ar',
  fallbackLocale: 'en',
  messages: {
    ar: Arabic.messages,
    en: English.messages
  }
})

const app = createApp(App)
app.use(store).use(VueAxios, axios).use(router).component('errorAlert', ErrorAlert).use(VueTheMask)
.component('loader', MiniLoader).component('mainloader', Loader).component('success', SuccessAlert).
component('placeHolder', placeHolder).component('Select2', Select2).use(i18n)
.component("v-select", vSelect).component('chargeWallet', popupCharge_Wallet);

app.config.globalProperties.$globalError = globalErrorHandler;
app.mount('#app');
